import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-body-2 font-weight-bold colorText mb-0" }
const _hoisted_2 = { class: "text-caption colorText mb-0" }

import { ref } from 'vue'

// Data Table Interfaces & Definitions
interface Device {
  name: string
  status: 'Conectado' | 'Buscando'
  signal: 'Excelente' | 'Aceptable' | 'Sin Señal'
  phyCell: string | number
  action: string
}

interface CellLoad {
  id: number
  details: string
  count: number
  colorClass: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardEjecutivoView',
  setup(__props) {

const headers = [
  { title: 'EQUIPO', key: 'name', sortable: false },
  { title: 'ESTADO', key: 'status', sortable: false },
  { title: 'CALIDAD SEÑAL', key: 'signal', sortable: false },
  { title: 'CELDA (PHY)', key: 'phyCell', sortable: false },
  { title: 'ACCIÓN', key: 'action', sortable: false }
]

const devices = ref<Device[]>([
  { name: 'GW02-HG5-24009', status: 'Conectado', signal: 'Excelente', phyCell: 4, action: '-' },
  { name: 'DT669-HG5-24021', status: 'Conectado', signal: 'Excelente', phyCell: 4, action: '-' },
  { name: 'ES030', status: 'Conectado', signal: 'Aceptable', phyCell: 1, action: 'Monitorear' },
  { name: 'DT682-HG5-24012', status: 'Buscando', signal: 'Sin Señal', phyCell: '-', action: 'Revisar Sitio' },
  { name: 'DT668-HG5-24019', status: 'Buscando', signal: 'Sin Señal', phyCell: '-', action: 'Revisar Sitio' }
])

const cells = ref<CellLoad[]>([
  { id: 4, details: 'B28@10Mhz (earfcn: 9260)', count: 4, colorClass: 'text-warning bg-slate-800' },
  { id: 1, details: 'B28@10Mhz (earfcn: 9260)', count: 2, colorClass: 'text-success bg-slate-800' }
])

// Helper Methods
const getSignalClass = (signal: Device['signal']) => {
  switch (signal) {
    case 'Excelente':
      return 'text-slate-100'
    case 'Aceptable':
      return 'text-warning font-weight-medium'
    case 'Sin Señal':
      return 'text-error font-weight-medium'
    default:
      return 'text-slate-100'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-8"
  }, {
    default: _withCtx(() => [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-flex justify-space-between align-center mb-6" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "text-h5 font-weight-bold colorText" }, " Dashboard Ejecutivo de Conectividad "),
          _createElementVNode("p", { class: "text-caption colorText mb-0" }, " Monitoreo unificado de infraestructura LTE ")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", { class: "text-caption colorText" }, " Última actualización: Hace unos segundos ")
        ])
      ], -1)),
      _createVNode(_component_v_row, { class: "mb-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "pa-4 border-slate-700",
                variant: "outlined",
                rounded: "lg"
              }, {
                default: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-overline font-weight-bold line-height-tight" }, [
                    _createElementVNode("span", {
                      class: "colorText",
                      color: "white"
                    }, " Disponibilidad de Flota ")
                  ], -1)),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-h4 font-weight-bold my-2 colorText" }, "75%", -1)),
                  _createVNode(_component_v_progress_linear, {
                    "model-value": "75",
                    color: "blue-accent-3",
                    height: "6",
                    rounded: "",
                    class: "mb-3"
                  }),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-caption colorText d-flex align-center gap-2" }, [
                    _createElementVNode("span", { class: "text-success font-weight-bold" }, "● 6 Online"),
                    _createElementVNode("span", { class: "mx-1" }, "|"),
                    _createElementVNode("span", { class: "text-error font-weight-bold" }, "● 2 Offline")
                  ], -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "pa-4 border-slate-700",
                variant: "outlined",
                rounded: "lg"
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "text-overline colorText font-weight-bold line-height-tight" }, " Salud de Red (SINR Promedio) ", -1),
                  _createElementVNode("div", { class: "text-h4 font-weight-bold my-2 colorText" }, "13 dB", -1),
                  _createElementVNode("div", { class: "text-caption text-success font-weight-medium mt-7" }, " ▲ Óptimo (>10dB) ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "pa-4 border-slate-700",
                variant: "outlined",
                rounded: "lg"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("div", { class: "text-overline colorText font-weight-bold line-height-tight" }, " Estabilidad (Uptime Promedio) ", -1),
                  _createElementVNode("div", { class: "text-h4 font-weight-bold my-2 colorText" }, "5h 42m", -1),
                  _createElementVNode("div", { class: "text-caption text-warning font-weight-medium mt-7" }, " ▼ Caídas detectadas recientemente ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "pa-4 border-slate-700",
                variant: "outlined",
                rounded: "lg"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "text-overline colorText font-weight-bold line-height-tight" }, " Alertas Críticas ", -1),
                  _createElementVNode("div", { class: "text-h4 font-weight-bold my-2 text-error" }, "2", -1),
                  _createElementVNode("div", { class: "text-caption colorText font-weight-medium mt-7" }, " Equipos buscando red ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            lg: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "pa-5 border-slate-700",
                variant: "outlined",
                rounded: "lg"
              }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold colorText mb-4" }, " Estado de Equipos Críticos ", -1)),
                  _createVNode(_component_v_data_table, {
                    headers: headers,
                    items: devices.value,
                    density: "comfortable",
                    class: "bg-transparent border-0 custom-table",
                    "hide-default-footer": ""
                  }, {
                    "item.status": _withCtx(({ item }) => [
                      _createVNode(_component_v_chip, {
                        color: item.status === 'Conectado' ? 'success' : 'error',
                        size: "small",
                        variant: "tonal",
                        class: "font-weight-bold"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.status), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    "item.signal": _withCtx(({ item }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(getSignalClass(item.signal))
                      }, _toDisplayString(item.signal), 3)
                    ]),
                    "item.action": _withCtx(({ item }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'text-error font-weight-bold': item.action === 'Revisar Sitio' })
                      }, _toDisplayString(item.action), 3)
                    ]),
                    _: 1
                  }, 8, ["items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            lg: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "pa-5 border-slate-700",
                variant: "outlined",
                rounded: "lg"
              }, {
                default: _withCtx(() => [
                  _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-subtitle-1 font-weight-bold colorText mb-4" }, " Carga por Estación Base ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cells.value, (cell, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: cell.id,
                      class: _normalizeClass(["d-flex justify-space-between align-center py-3", { 'border-b-thin border-slate-700': index !== cells.value.length - 1 }])
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h4", _hoisted_1, " Celda ID: " + _toDisplayString(cell.id), 1),
                        _createElementVNode("p", _hoisted_2, _toDisplayString(cell.details), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["cell-badge text-body-1 font-weight-bold px-3 py-1 rounded-lg", cell.colorClass])
                      }, _toDisplayString(cell.count), 3)
                    ], 2))
                  }), 128)),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mt-4 pt-4 border-t-dashed border-slate-700" }, [
                    _createElementVNode("p", { class: "text-caption colorText mb-0" }, " La Celda 4 concentra el 66% del tráfico actual. Se sugiere balanceo si se agregan más equipos. ")
                  ], -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})